import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { emptyArray } from 'ui-components/default-props/empty';
import { HeaderGroupPropType, RowPropType } from '../../../../../../../prop-types/react-table';

import style from './edit-amount-summary-modal.module.less';

export const EditAmountSummaryTable = ({
  getTableProps,
  headerGroups = emptyArray,
  getTableBodyProps,
  rows = emptyArray,
  prepareRow,
  selectedFulfillmentPlan,
}) => {
  const { getHeaderGroupProps, headers } = headerGroups[0];

  return (
    <div {...getTableProps()} className={style['items-table']} role='table'>
      {/* eslint-disable-next-line jsx-a11y/prefer-tag-over-role */}
      <div {...getHeaderGroupProps()} className={style['header-row']} role='rowgroup'>
        {headers.map((column) => {
          const { key: headerCellKey, ...rest } = column.getHeaderProps();
          return (
            <div key={headerCellKey} className={classnames(style.cell, style['header-cell'])} {...rest} role='row'>
              {column.header && column.render('header')}
            </div>
          );
        })}
      </div>
      {/* eslint-disable-next-line jsx-a11y/prefer-tag-over-role */}
      <div {...getTableBodyProps()} role='rowgroup'>
        {rows.map((row) => {
          prepareRow(row);
          const { key: rowKey, ...rowProps } = row.getRowProps() || {};
          const selectedRow = Number(selectedFulfillmentPlan) === Number(row.original.id) ? 'selected' : undefined;
          return (
            <div key={rowKey} className={classnames(style['body-row'], style[selectedRow])} role='row'>
              <div {...rowProps}>
                {row.cells.map((cell, cellIndex) => {
                  const { key: cellKey, ...cellProps } = cell.getCellProps();
                  const isFirstColumn = cellIndex === 0;
                  return (
                    <div key={cellKey} className={isFirstColumn ? style['shipment-cell'] : style.cell} {...cellProps} role='cell'>
                      {cell.render('cell')}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

EditAmountSummaryTable.propTypes = {
  headerGroups: PropTypes.arrayOf(HeaderGroupPropType),
  rows: PropTypes.arrayOf(RowPropType),
  getTableProps: PropTypes.func.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  selectedFulfillmentPlan: PropTypes.string,
};
